export const MARKETING_AUTOMATED_CAMPAIGN_TYPE_TABS_FLAG =
  'hermes.marketingAutomatedCampaignTypeTabs'
